/** 浏览器上传与IM导入共用的类型名称；实际内容仍由Host输入存储校验。 */
const MEDIA_TYPE_BY_EXT: Record<string, string> = {
  zip: 'application/zip', txt: 'text/plain', md: 'text/markdown', pdf: 'application/pdf',
  png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', webp: 'image/webp',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
export const HOST_INPUT_MEDIA_TYPES = [...new Set(Object.values(MEDIA_TYPE_BY_EXT))];

/** 空或通用MIME按扩展名补全；明确声明的未知类型不伪装成可支持类型。 */
export function resolveHostInputMediaType(fileName: string, declared = ''): string {
  const type = declared.split(';')[0].trim().toLowerCase();
  if (type === 'application/x-zip-compressed' || type === 'application/x-zip') return 'application/zip';
  const extension = fileName.includes('.') ? fileName.split('.').pop()!.toLowerCase() : '';
  return type && type !== 'application/octet-stream' ? type : MEDIA_TYPE_BY_EXT[extension] || type;
}
